import React, { useState, useEffect } from 'react';
import qs from 'qs';

export function punchoutInQueryString() {
  const queryString = window.location.search.split('?').pop();
  const queryParams = qs.parse(queryString);
  const punchout = queryParams.punchout || null;
  return !!punchout;
}

export function punchoutSessionInQueryString() {
  const queryString = window.location.search.split('?').pop();
  const queryParams = qs.parse(queryString);
  const punchout = queryParams.punchout_session_id || '';
  return punchout;
}

export const PunchOutContext = React.createContext({
  punchOut: false,
  punchoutSessionId: '',
});

export default function PunchOutContextStore({ children }) {
  let initialPunchoutValue = false;
  let initialPunchoutSession = '';
  try {
    initialPunchoutValue =
      !!sessionStorage.getItem('punch_out_flag') &&
      !!JSON.parse(sessionStorage.getItem('punch_out_flag'));
  } catch (error) {
    console.log(error);
    initialPunchoutValue = false;
  }
  try {
    initialPunchoutSession = sessionStorage.getItem('punchout_session_id')
      ? JSON.parse(sessionStorage.getItem('punchout_session_id'))
      : '';
  } catch (error) {
    console.log(error);
    initialPunchoutSession = '';
  }
  const [punchOut, setPunchOut] = useState(initialPunchoutValue);
  const [punchoutSessionId, setPunchoutSessionId] = useState(
    initialPunchoutSession
  );

  useEffect(() => {
    const punchOutFlagQueryString = punchoutInQueryString();
    const punchoutSessionQueryString = punchoutSessionInQueryString();
    const punchOutFlag = punchOutFlagQueryString || punchOut;
    const localPunchoutSessionId =
      punchoutSessionQueryString || punchoutSessionId;
    window.sessionStorage.setItem(
      'punch_out_flag',
      JSON.stringify(punchOutFlag)
    );
    window.sessionStorage.setItem(
      'punchout_session_id',
      JSON.stringify(localPunchoutSessionId)
    );
    setPunchOut(punchOutFlag);
    setPunchoutSessionId(localPunchoutSessionId);
  }, [punchOut, punchoutSessionId]);

  const value = {
    punchOut,
    punchoutSessionId,
  };
  return (
    <PunchOutContext.Provider value={value}>
      {children}
    </PunchOutContext.Provider>
  );
}
